import React from 'react';
import { Box, Typography } from '@mui/material';
import { TEMPLATES } from '../templates';
import TemplateGallery from '../TemplateGallery';

const Templates = () => (
  <Box sx={{ px: { xs: 2, md: 4 }, pt: { xs: 14, md: 18 }, pb: { xs: 8, md: 12 } }}>
    <Box sx={{ maxWidth: 1240, mx: 'auto' }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" sx={{ fontSize: { xs: 34, md: 52 }, mb: 1.5 }}>Website templates</Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 17, maxWidth: 560, mx: 'auto' }}>
          {TEMPLATES.length} ready-made designs for shops, restaurants, studios and services. Open any demo to see it live.
        </Typography>
      </Box>
      <TemplateGallery />
    </Box>
  </Box>
);

export default Templates;
